import ActionTypes from '../../../constants/ActionTypes';
import { ISessionDataState } from "./types";
import _ from 'lodash';
import ApiUrls from '../../../constants/ApiUrls';

const initialState: ISessionDataState = {
  user: {
    isLoggedIn: false,
    isAgent: false,
    firstName: '',
    lastName: '',
    userName: '',
    numberOfOrderItems: 0,
    email: '',
    telenorNalogId: '',
    wishlist: [],
    avatarUrl: null
  },
  flashMessages: [],
  gtmData: {
    gtmUserId: '',
    gtmAgentType: ''
  },
  numberOfOrderItems: 0,
  redirectUser: false
};

export default (state = initialState, action: any) : ISessionDataState => {
  if (action.type.includes(ActionTypes.SESSION_DATA.SET)) {
    let sessionState = { ...state };
    if (_.has(action.payload, 'session.user')) {
      sessionState = { ...sessionState, user: action.payload.session.user };
    }
    if (_.has(action.payload, 'session.flashMessages')) {
      sessionState = { ...sessionState, flashMessages: action.payload.session.flashMessages };
    }
    if (_.has(action.payload, 'session.gtmData')) {
      sessionState = { ...sessionState, gtmData: action.payload.session.gtmData };
    }
    if (_.has(action.payload, 'session.numberOfOrderItems')  && action.payload?.source === ApiUrls.PAGES_HEADER) {
      sessionState = { ...sessionState, numberOfOrderItems: action.payload.session.numberOfOrderItems };
    }
    if (_.has(action.payload, 'session.redirectUser')) {
      sessionState = { ...sessionState, redirectUser: action.payload.session.redirectUser };
    }
    return sessionState;
  }
  return state;
};
